import { createFileRoute } from '@tanstack/react-router';

import { AdsTxtLayout } from '../features/supply/adsTxt/components/AdsTxtLayout';

export const Route = createFileRoute('/supply/ads-txt')({ component: AdsTxtLayout });
